import { NgModule } from '@angular/core';
import { AppsSharedModule, BaseInquiryModule, BaseSharedModule, BaseAssignmentsModule } from 'base';
import { BaseCustomerInquiryUnlimitedOffersComponent } from './_components/inquiry-unlimited-offers/base-customer-inquiry-unlimited-offers.component';
import { BaseCustomerOfferInfoModalComponent } from './_components/offer-info-modal/base-customer-offer-info-modal.component';
import { BaseCustomerOfferInformationTabComponent } from './_components/offer-info-modal/offer-information-tab/base-customer-offer-information-tab.component';
import { BaseCustomerSharedModule } from '../../shared/base-customer-shared.module';
import { BaseCustomerInquiryListComponent } from './_components/inquiry-list/base-customer-inquiry-list.component';
import { BaseCustomerInquiryListFiltersComponent } from './_components/inquiry-list/inquiry-list-filters/base-customer-inquiry-list-filters.component';
import { BaseCustomerShiftPlanComponent } from './_components/shift-plan/base-customer-shift-plan.component';
import { BaseCustomerShiftPlanMdComponent } from './_components/shift-plan-md/base-customer-shift-plan-md.component';
import { BaseCustomerShiftPlanMdOrganizerComponent } from './_components/shift-plan-md/_components/shift-plan-md-organizer/base-customer-shift-plan-md-organizer.component';
import { BaseCustomerSimilarInquiriesMdComponent } from './_components/shift-plan-md/_components/similar-inquiries-md/base-customer-similar-inquiries-md.component';
import { BaseCustomerSimilarInquiriesMdCalendarComponent } from './_components/shift-plan-md/_components/similar-inquiries-md/_components/similar-inquiries-md-calendar/base-customer-similar-inquiries-md-calendar.component';
import { BaseCustomerSimilarInquiriesMdCalendarScrollComponent } from './_components/shift-plan-md/_components/similar-inquiries-md/_components/similar-inquiries-md-calendar/_components/similar-inquiries-md-calendar-scroll/base-customer-similar-inquiries-md-calendar-scroll.component';
import { BaseCustomerSimilarInquiriesMdInquiryComponent } from './_components/shift-plan-md/_components/similar-inquiries-md/_components/similar-inquiries-md-inquiry/base-customer-similar-inquiries-md-inquiry.component';
import { BaseCustomerShiftDetailsModalComponent } from './_components/shift-plan/details-modal/base-customer-shift-details-modal.component';
import { BaseCustomerShiftPlanSidebarComponent } from './_components/shift-plan/sidebar/base-customer-shift-plan-sidebar.component';
import { BaseCustomerSortFilterDropdownComponent } from './_components/sort-filter-dropdown/base-customer-sort-filter-dropdown.component';
import { InquiryOffersListFiltersComponent } from './_components/inquiry-offers-list-filters/inquiry-offers-list-filters.component';
import { BaseCustomerInquiryOffersComponent } from './_components/inquiry-offers/base-customer-inquiry-offers.component';
import { BaseCustomerInquiryOffersListComponent } from './_components/inquiry-offers/inquiry-offers-list/base-customer-inquiry-offers-list.component';
import { BaseCustomerOfferInfoMasterDataTabComponent } from './_components/offer-info-modal/offer-master-data-tab/base-customer-offer-master-data-tab.component';
import { BaseCustomerOfferDocumentsTabComponent } from './_components/offer-info-modal/offer-documents-tab/base-customer-offer-documents-tab.component';
import { BaseCustomerOfferDocumentComponent } from './_components/offer-info-modal/offer-master-data-tab/_components/base-customer-offer-document/base-customer-offer-document.component';
import { BaseCustomerOffersSearchAndLegendComponent } from './_components/offers-search-and-legend/base-customer-offers-search-and-legend.component';
import { BaseCustomerOfferBubbleListComponent } from './_components/offer-bubble-list/base-customer-offer-bubble-list.component';
import { BaseCustomerOfferBubbleComponent } from './_components/offer-bubble/base-customer-offer-bubble.component';
import { BaseCustomerOfferAvailableShiftTypeExistsPipe } from './_pipes/base-customer-offer-available-shift-type-exists.pipe';
import { BaseCustomerOfferActionsComponent } from './_components/offer-actions/base-customer-offer-actions.component';
import { BaseCustomerShiftPlanCalendarComponent } from './_components/shift-plan/calendar/base-customer-shift-plan-calendar.component';
import { BaseCustomerShiftPlanCalendarDatesComponent } from './_components/shift-plan/calendar/dates/base-customer-shift-plan-calendar-dates.component';
import { BaseCustomerShiftPlanBubbleComponent } from './_components/shift-plan/bubble/base-customer-shift-plan-bubble.component';
import { BaseCustomerShiftPlanSimilarInquiriesComponent } from './_components/shift-plan/similar-inquiries/base-customer-shift-plan-similar-inquiries.component';
import { BaseSimilarInquiriesDatesListComponent } from './_components/shift-plan/similar-inquiries/dates/base-similar-inquiries-dates-list.component';
import { CloseInquiryFormComponent } from './_components/close-inquiry-form/close-inquiry-form.component';
import { BaseCustomerUnlimitedOfferActionsComponent } from './_components/unlimited-offer-actions/base-customer-unlimited-offer-actions.component';
import { BaseCustomerInquiryOfferComponent } from './_components/inquiry-offers/inquiry-offer/base-customer-inquiry-offer.component';
import { BaseCustomerInquiryListItemComponent } from './_components/inquiry-list/inquiry-list-item/base-customer-inquiry-list-item.component';
import { BaseCustomerInquiryUnlimitedOfferComponent } from './_components/inquiry-unlimited-offers/inquiry-unlimited-offer/base-customer-inquiry-unlimited-offer.component';
import { BaseCustomerInquiredServiceProvidersModalComponent } from './_components/inquired-service-providers-modal/base-customer-inquired-service-providers-modal.component';
import { BaseCustomerInquiredServiceProviderListItemComponent } from './_components/base-customer-inquired-service-provider-list-item/base-customer-inquired-service-provider-list-item.component';
import { BaseCustomerExternalEmployeeModule } from '../external-employee/external-employee.module';
import { BaseCustomerAlternativeOffersHeadlineComponent } from './_components/alternative-offers-headline/alternative-offers-headline.component';

@NgModule({
  imports: [
    BaseSharedModule,
    AppsSharedModule,
    BaseInquiryModule,
    BaseAssignmentsModule,
    BaseCustomerSharedModule,
    BaseCustomerExternalEmployeeModule,
  ],
  declarations: [
    BaseCustomerOfferBubbleComponent,
    BaseCustomerOfferInfoModalComponent,
    BaseCustomerOfferInfoMasterDataTabComponent,
    BaseCustomerOfferDocumentsTabComponent,
    BaseCustomerOfferInformationTabComponent,
    BaseCustomerOffersSearchAndLegendComponent,
    BaseCustomerInquiryListComponent,
    BaseCustomerInquiryListFiltersComponent,
    BaseCustomerInquiryUnlimitedOffersComponent,
    BaseCustomerShiftPlanComponent,
    BaseCustomerShiftPlanMdComponent,
    BaseCustomerShiftPlanMdOrganizerComponent,
    BaseCustomerSimilarInquiriesMdComponent,
    BaseCustomerSimilarInquiriesMdCalendarComponent,
    BaseCustomerSimilarInquiriesMdCalendarScrollComponent,
    BaseCustomerSimilarInquiriesMdInquiryComponent,
    BaseCustomerShiftDetailsModalComponent,
    BaseCustomerShiftPlanSidebarComponent,
    BaseCustomerSortFilterDropdownComponent,
    InquiryOffersListFiltersComponent,
    BaseCustomerOfferDocumentComponent,
    BaseCustomerInquiryOffersComponent,
    BaseCustomerInquiryOffersListComponent,
    BaseCustomerOfferBubbleListComponent,
    BaseCustomerShiftPlanCalendarComponent,
    BaseCustomerShiftPlanCalendarDatesComponent,
    BaseCustomerShiftPlanBubbleComponent,
    BaseCustomerOfferAvailableShiftTypeExistsPipe,
    BaseCustomerOfferActionsComponent,
    BaseCustomerShiftPlanSimilarInquiriesComponent,
    BaseSimilarInquiriesDatesListComponent,
    CloseInquiryFormComponent,
    BaseCustomerUnlimitedOfferActionsComponent,
    BaseCustomerInquiryOfferComponent,
    BaseCustomerInquiryListItemComponent,
    BaseCustomerInquiryUnlimitedOfferComponent,
    BaseCustomerInquiredServiceProvidersModalComponent,
    BaseCustomerInquiredServiceProviderListItemComponent,
    BaseCustomerAlternativeOffersHeadlineComponent,
  ],
  exports: [
    BaseCustomerOfferBubbleComponent,
    BaseCustomerOfferInfoModalComponent,
    BaseCustomerOfferInfoMasterDataTabComponent,
    BaseCustomerOfferDocumentsTabComponent,
    BaseCustomerOfferInformationTabComponent,
    BaseCustomerOffersSearchAndLegendComponent,
    BaseCustomerInquiryListComponent,
    BaseCustomerInquiryListFiltersComponent,
    BaseCustomerInquiryUnlimitedOffersComponent,
    BaseCustomerShiftPlanComponent,
    BaseCustomerShiftPlanMdComponent,
    BaseCustomerShiftDetailsModalComponent,
    BaseCustomerShiftPlanSidebarComponent,
    BaseCustomerSortFilterDropdownComponent,
    InquiryOffersListFiltersComponent,
    BaseCustomerOfferDocumentComponent,
    BaseCustomerInquiryOffersComponent,
    BaseCustomerInquiryOffersListComponent,
    BaseCustomerOfferBubbleListComponent,
    BaseCustomerShiftPlanBubbleComponent,
    BaseCustomerShiftPlanSimilarInquiriesComponent,
    BaseSimilarInquiriesDatesListComponent,
    CloseInquiryFormComponent,
    BaseCustomerUnlimitedOfferActionsComponent,
    BaseCustomerInquiryOfferComponent,
    BaseCustomerInquiryListItemComponent,
    BaseCustomerInquiryUnlimitedOfferComponent,
    BaseCustomerInquiredServiceProvidersModalComponent,
    BaseCustomerInquiredServiceProviderListItemComponent,
  ],
})
export class BaseCustomerInquiryModule {}
